import {EmploymentStatus, PayrollStatus, SalaryChangeStatus} from "../../app/interfaces";
import styled from "styled-components";
import {EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED} from "../../utils/constants";
import {colorForStatus} from "../../utils";

interface StatusPillProps {
    status: EmploymentStatus | PayrollStatus | SalaryChangeStatus
}

export const StatusPill = styled.div<StatusPillProps>`
  text-align: center;
  border-radius: 4px;
  padding: 5px 12px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  width: fit-content;
  color: ${props => colorForStatus(props.status).color};
  background: ${props => colorForStatus(props.status).background};
  ${props => props.status === EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED ? 'border: 1px solid #9FA2B4;': ''}
`;
